<template>
  <div>
    <div class="jumbotron">
      <div class="mask"></div>
      <b-row class="mx-auto py-5 text-left" style="max-width: 1460px">
        <b-col sm="12">
          <h1 class="text-white"><b>istruzioni per i Traduttori</b></h1>
        </b-col>
      </b-row>
    </div>

    <b-row class="m-2 mx-auto" style="max-width: 1460px">
      <b-col lg="12" class="text-left">
        <p>Innanzitutto grazie per il tuo contributo che è fondamentale!</p>
        <ol>
          <li>Compila il modulo per registrarti. Indica la lingua o le lingue in cui sei in grado di tradurre.</li>
          <li>
            Una volta accreditato accedi alla tua area. Qui troverai una tabella con tutti i lavori da tradurre nella
            lingua o nelle lingue che hai indicato.
          </li>
          <li>
            Puoi visualizzare il testo di partenza cliccando sul titolo nella prima colonna della tabella (“Documento
            originale”) e, se disponibile, puoi vedere un’anteprima della traduzione automatica cliccando su “Scarica
            traduzione automatica”.
          </li>
          <li>
            Se dopo averlo visualizzato, vuoi fare il lavoro, basta cliccare su “Prendi in carico” nell’ultima colonna.
            Il lavoro passerà quindi nella sezione “Richieste in lavorazione”, dove potrai scaricare i documenti
            disponibili e iniziare la revisione.
          </li>
          <li>
            La traduzione automatica è pensata per aiutarti: puoi utilizzarla come base per il tuo lavoro oppure, se
            preferisci, puoi ignorarla e ritradurre il file originale manualmente.
          </li>
          <li>
            Dopo aver tradotto il testo, caricalo cliccando su “Carica revisione”, selezionando il tuo documento
            tradotto e confermando con “OK”.
          </li>
          <li>A questo punto il lavoro è finito!</li>
        </ol>

        <h3>COSA FARE IN CASO DI MALFUNZIONAMENTO TECNICO</h3>
        <p>
          Puoi segnalare eventuali bug scrivendo a help@languageaid.org, avendo cura di specificare in modo quanto più
          preciso possibile il tipo di disservizio riscontrato e le circostanze in cui si è verificato (<b
            >fai uno screenshot della pagina in cui si è verificato l'errore</b
          >, mettendo in evidenza l'errore. Indicaci chiaramente l'indirizzo della pagina in cui è avvenuto l'errore.).
        </p>

        <h3>COSA FARE IN CASO DI SMARRIMENTO DELLA PASSWORD</h3>
        <p>
          E' buona norma usare password sicure (es. combinazioni di parole, caratteri speciali e cifre) che possano
          essere ricordate facilmente.
        </p>

        <p>
          Tuttavia, nella malaugurata eventualità in cui dovessi non ricordare la tua password, scrivici brevemente a
          help@languageaid.org. Provvederemo a resettare la tua password e inviare all’indirizzo e-mail indicato una
          nuova mail di conferma per impostarne una nuova.
        </p>

        <h3>COSA FARE IN CASO DI CONSEGNA DEL FILE ERRATO</h3>
        <p>
          E' possibile caricare nuovamente una traduzione cliccando sul pulsante di colore azzurro con il simbolo di un
          documento posto accanto al pulsante “Doc. revisionato”; il nuovo documento sostituirà il precedente,
          l’associazione riceverà un alert e prenderà in considerazione l’ultimo testo caricato.
        </p>

        <h3>COSA FARE IN CASO DI CONTENUTO INAPPROPRIATO</h3>
        <p>
          Qualora tra le richieste in cerca di revisione o in lavorazione dovessi trovare un testo non conforme ad una
          situazione umanitaria/sociale/sanitaria, oppure una richiesta di traduzione di un volume imponente (ad es.
          molto superiore a 2 o 3 pagine), vi preghiamo di segnalarcelo inviando una mail a info@languageaid.org .
        </p>

        <h3>MIGLIORIAMO INSIEME</h3>
        <p>
          Vi ricordiamo inoltre che potete segnalarci i vostri suggerimenti e desiderata per rendere sempre più
          efficiente la piattaforma.
        </p>

        <b>CONTATTI:</b> <a href="mailto:info@languageaid.org">info@languageaid.org</a><br />
        <b>ASSISTENZA:</b> <a href="help@languageaid.org">help@languageaid.org</a><br />
        <hr class="btn-outline-primary" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "HelpTranslators",
};
</script>

<style scoped>
.jumbotron {
  background-image: url("/img/bg-home.png");
  background-position-y: 80%;
}
</style>
